/* eslint-disable max-len */
import React from 'react';
import { SvgProps, IconType } from '../../types/types';

export const Region: IconType = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41 20.1515C41 27.99 30.0137 39.0863 25.4201 43.6028C24.6325 44.3773 23.3618 44.3744 22.5744 43.5997C18.1393 39.2361 7 27.9071 7 20.1515C7 11.303 13.3208 4 24 4C35.3208 4 41 11.303 41 20.1515Z"
        stroke="#7D7FE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="24.0002"
        cy="19.9999"
        r="8.25"
        stroke="#7D7FE8"
        strokeWidth="1.83333"
      />
      <path
        d="M19.2314 27.8303C19.5557 28.0268 19.8957 28.2037 20.25 28.3645C19.9041 28.2092 19.5686 28.0354 19.2471 27.8401L19.2314 27.8303ZM28.7686 27.8303C28.4536 28.0226 28.1246 28.1931 27.7861 28.3469C28.1272 28.1905 28.4555 28.0201 28.7686 27.8303ZM21.25 22.7502V23.6672C21.2501 24.1712 21.4298 24.6029 21.7891 24.9622C22.1477 25.3207 22.579 25.5002 23.083 25.5002V27.2874C21.2346 27.0582 19.7034 26.2487 18.4893 24.8586C17.2744 23.4684 16.6563 21.9025 16.6562 20.054C16.6562 19.779 16.6643 19.4334 16.7021 19.1584C16.7406 18.8835 16.7594 18.6749 16.8496 18.3499L21.25 22.7502ZM26.75 13.179C28.1402 13.729 29.2521 14.6603 30.085 15.8977C30.9173 17.1352 31.333 18.503 31.333 20.0002C31.333 20.4585 31.3064 20.9576 31.2227 21.4006C31.1383 21.8435 31.0174 22.3052 30.8574 22.7249C30.6967 23.1453 30.511 23.5358 30.2666 23.925C30.0222 24.3149 29.7362 24.702 29.4082 24.9504C29.286 24.5685 29.064 24.2588 28.7432 24.0217C28.4225 23.7854 28.064 23.6673 27.667 23.6672H26.75V20.9172C26.75 20.6575 26.6617 20.4389 26.4863 20.2629C26.3104 20.0878 26.0926 20.0002 25.833 20.0002H20.333V18.1672H22.167C22.4265 18.1671 22.6444 18.0785 22.8203 17.9026C22.9955 17.7273 23.083 17.5098 23.083 17.2502V15.4172H24.917C25.4209 15.4171 25.8527 15.2373 26.2119 14.8782C26.5706 14.5195 26.75 14.0874 26.75 13.5833V13.179ZM32.3496 23.7815C32.196 24.1202 32.0242 24.4487 31.832 24.7639C32.0217 24.4507 32.1933 24.1229 32.3496 23.7815ZM15.6504 23.7815C15.7679 24.0381 15.894 24.2869 16.0303 24.5276C15.8925 24.2856 15.7661 24.0366 15.6504 23.7815ZM15.9463 15.6184C15.8351 15.8231 15.7327 16.0344 15.6348 16.2502C15.7312 16.0354 15.8341 15.8241 15.9463 15.6184ZM31.832 15.2356C32.0303 15.5608 32.207 15.9001 32.3643 16.2502C32.2041 15.8973 32.0276 15.5587 31.832 15.2356ZM28.1152 11.8098C28.2914 11.8985 28.4643 11.9925 28.6338 12.092C28.4648 11.9933 28.2922 11.8991 28.1152 11.8098ZM16.0449 15.4485C16.0125 15.5053 15.9776 15.5607 15.9463 15.6184C15.9777 15.5609 16.0124 15.5053 16.0449 15.4485ZM19.6182 11.9465C19.7085 11.8973 19.8005 11.8512 19.8926 11.8049C19.8003 11.8514 19.7083 11.8975 19.6182 11.9465Z"
        fill="#7D7FE8"
      />
      <path
        d="M21 35L21.7812 35.5208C23.1248 36.4165 24.8752 36.4165 26.2188 35.5208L27 35"
        stroke="#6668C4"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
